import { Font } from './Font';

export type Theme = {
  experienceBackgroundColor?: string;
  experienceBorder?: string;
  experiencePadding?: string;
  experienceTextAlignment?: string;
  errorColor?: string;
  font?: Font;
  primaryColor?: string;
  secondaryColor?: string;
};

export const defaultTheme: Theme = {
  experienceBackgroundColor: '#F8F8F9',
  errorColor: '#ff4d4f',
  font: Font.ROBOTO,
  primaryColor: '#4298b5',
  secondaryColor: '#4298b5',
};
